import { getPallettesByCategoryAndBucket as A } from "@placer-ui/components";
const O = "pk.eyJ1IjoicGxhY2VybWFwdGVhbSIsImEiOiJja3d6NTh4aGkwa2pwMndvNjRnZDR2Zmc0In0.8J8KJ5IxdOF3gTEs8HVM2Q", E = A(
  "trade-area",
  1
), _ = A(
  "heatmap",
  5
), t = A(
  "traffic-volume",
  6
), L = A(
  "trade-area",
  1
), P = {
  "POI-1-TA": [121, 125, 246],
  "POI-2-TA": [233, 139, 155],
  "POI-3-TA": [65, 200, 184],
  "POI-4-TA": [225, 196, 65],
  "POI-5-TA": [221, 140, 70],
  "POI-6-TA": [79, 172, 252],
  "POI-7-TA": [161, 204, 62],
  "POI-8-TA": [228, 148, 229]
};
export {
  L as DEFAULT_COLOR_SEQUENTIAL_PALETTE_COLORS,
  E as DEFAULT_COLOR_TRADE_AREA_PALETTE_COLORS,
  t as DEFAULT_COLOR_VTV_PALETTE_COLORS,
  _ as DEFAULT_HEATMAP_COLOR_TRADE_AREA_PALETTE_COLORS,
  O as PLACER_MAP_TEAM_TOKEN,
  P as TAStrokeColors
};
//# sourceMappingURL=index.es59.js.map
